import React from 'react';
import {fromJS} from 'immutable';
import appStore from 'client/AppStore';
import {dateRangeOptions, RANGES} from 'generic/SelectableDateRange/shared';
import SelectableDateRange from 'generic/SelectableDateRange/SelectableDateRange.react';
import Tabs from 'sg/Tabs/Tabs.react';
import usageReportsStore from './UsageReports.store';
import './usage-reports.scss';

const tabs = fromJS([
  {
    label: 'Teachers',
    to: 'teachers'
  },
  {
    label: 'Students',
    to: 'students'
  },
  {
    label: 'Classes',
    to: 'classes'
  },
  {
    label: 'Subjects',
    to: 'subjects'
  }
]);

export default class UsageReports extends React.Component {
  render() {
    const dateRanges = dateRangeOptions
      .filterNot((range) => {
        return ['All-time', 'Last week', 'Last month'].includes(range.get('name'));
      })
      .map((range) => {
        return range.get('name') === 'Custom'
          ? range
          : range.set('shouldHideDateRangeSelector', true);
      });

    return (
      <div className='u-pad_4'>
        <SelectableDateRange
          storeName={usageReportsStore.getSelectableDateRangeStoreName()}
          className='usage-reports__date-range'
          options={dateRanges}
          defaultDateRange={RANGES.THIS_SCHOOL_YEAR}
          shouldHideDateRangeSelector
        />
        <Tabs
          className='usage-reports__tabs'
          content={tabs}
          baseUrl={`/school-admin/${appStore.routerProps.params.schoolId}/usage-reports`}
        >
          {this.props.children && React.cloneElement(this.props.children, {})}
        </Tabs>
      </div>
    );
  }
}
